'use es6';

import { agentTypeToSenderType } from 'conversations-message-history/senders/operators/agentTypeToSenderType';
import Sender from 'conversations-message-history/senders/records/Sender';
import { getAgentType, getAvatar, getEmail, getFirstName, getLastName, getUserId } from 'conversations-internal-schema/responders/operators/responderGetters';
import { defaultMemoize } from 'reselect';
export const getResponderAsSender = defaultMemoize((responder, id, type) => {
  const senderType = agentTypeToSenderType(getAgentType(responder) || type);
  return new Sender({
    id: getUserId(responder) || id,
    avatar: getAvatar(responder),
    firstName: getFirstName(responder),
    email: getEmail(responder),
    lastName: getLastName(responder),
    senderType
  });
});